// eslint-disable-next-line import/no-extraneous-dependencies
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns'
import generatePicker from 'antd/es/date-picker/generatePicker'
import 'antd/es/date-picker/style/index'

export const DatePicker = generatePicker<Date>(dateFnsGenerateConfig)
